// // Instagram section Slider js 

const s = document.querySelector('.instafeed-new-layout-wrapper');
if (!s) return;

let d=false, x, l;

// Drag
s.onmousedown = e => (d=true, x=e.pageX, l=s.scrollLeft, s.classList.add('dragging'));
s.onmouseup = s.onmouseleave = () => (d=false, s.classList.remove('dragging'));
s.onmousemove = e => d && (s.scrollLeft = l-(e.pageX-x));

// Touch
s.ontouchstart = e => (x=e.touches[0].pageX, l=s.scrollLeft);
s.ontouchmove  = e => (s.scrollLeft = l-(e.touches[0].pageX-x));

// Wheel
s.onwheel = e => s.scrollLeft += e.deltaY;

// Arrows
document.querySelector('.insta-arrow-left')?.addEventListener('click', ()=>s.scrollBy({left:-300,behavior:'smooth'}));
document.querySelector('.insta-arrow-right')?.addEventListener('click', ()=>s.scrollBy({left:300,behavior:'smooth'}));

// // Instagram section Slider js End